import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthFacade, Helper } from '@piqet-angular/data';
import { MustMatch } from '../register/must-match.validator';

@Component({
  selector: 'piqet-angular-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm!: FormGroup;
  submitted = false;
  email: any;
  fieldTextType: boolean = false;
  fieldTextTypeNewPwd: boolean = false;

  specialCharactersflag: boolean = true;
  upperCaseCharactersflag: boolean = true;
  lowerCaseCharactersflag: boolean = true;
  numberCharactersflag: boolean = true;
  minLengthsflag: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    public authFacade: AuthFacade,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const pwdReg = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';
    this.resetPasswordForm = this.formBuilder.group(
      {
        password: ['', [Validators.required, Validators.pattern(pwdReg)]],
        confirmPassword: ['', Validators.required],
      },
      {
        validator: MustMatch('password', 'confirmPassword'),
      }
    );
    this.email = atob(this.activeRoute.snapshot.queryParams['mail']);
  }
  toggleFieldOldPwd() {
    this.fieldTextType = !this.fieldTextType;
  }
  toggleFieldNewPwd() {
    this.fieldTextTypeNewPwd = !this.fieldTextTypeNewPwd;
  }

  validationsPassword() {
    const isValidate = Helper.passwordValidatior(this.resetPasswordForm.controls['password'].value);
    this.upperCaseCharactersflag = isValidate.upperCaseCharactersflag;
    this.lowerCaseCharactersflag = isValidate.lowerCaseCharactersflag;
    this.numberCharactersflag = isValidate.numberCharactersflag;
    this.specialCharactersflag = isValidate.specialCharactersflag;
    this.minLengthsflag = isValidate.minLengthsflag;
  }
  submit() {
    this.submitted = true;
    if (!this.resetPasswordForm.valid) {
      return;
    }
    const data = {
      email: this.email,
      password: this.resetPasswordForm.controls['password'].value,
    };
    this.authFacade.resetPassword(data);
  }
}
